import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { graphql } from 'gatsby'
import { Container } from 'chaoskit/src/components'
import { gradient } from 'chaoskit/src/assets/styles/utility'
import { StylesContainerVariables } from 'chaoskit/src/components/Container'
import { motion } from 'framer-motion'

import BaseLayout from '~layouts/BaseLayout'
import Data from '~components/Data'
import Hero, { HeroContent, HeroTitle } from '~partials/Hero'
import HelmetSEO from '~partials/global/HelmetSEO'
import ProductOverview from '~partials/product/ProductOverview'
import HeroDashboard from '~partials/product/HeroDashboard'

const Product = ({
  data: {
    file: {
      childMdx: { frontmatter: pageData },
    },
  },
}) => {
  const theme = useTheme()

  return (
    <BaseLayout footerProps={{ hideCTA: true }}>
      <HelmetSEO title={pageData.title} description={pageData.description} />
      <Hero css={{ ...gradient.dark(theme), overflow: 'hidden' }}>
        <HeroContent css={{ textAlign: 'center' }}>
          <Container>
            <HeroTitle
              as={motion.h1}
              initial={{
                opacity: 0,
                y: '-25%',
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              size="large"
              css={{
                // @NOTE Just a bit more breathing room for larger dashboard graphic
                [theme.mq.medium]: {
                  marginTop: theme.space.large,
                  marginBottom: theme.space.large,
                },
              }}
            >
              <Data>{pageData.hero.heading}</Data>
            </HeroTitle>
          </Container>
          <div
            css={{
              maxWidth: StylesContainerVariables.extended,
              marginLeft: 'auto',
              marginRight: 'auto',
              marginBottom: -100, // @NOTE Is the same as our angular cut-out graphic
              transform: 'translateX(-7.6%)', // @NOTE Approximate "nudge" for center alignment of graphic
            }}
          >
            <HeroDashboard />
          </div>
        </HeroContent>
        <svg
          css={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: 100,
            display: 'none',
            zIndex: 2,

            [theme.mq.medium]: {
              display: 'block',
            },
          }}
          fill="#fff"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <polygon
            css={{ filter: `drop-shadow(0 0 5px ${theme.color.dark.base})` }}
            points="0,100 100,0 100,100"
          />
        </svg>
      </Hero>
      <ProductOverview />
    </BaseLayout>
  )
}

Product.propTypes = {
  data: PropTypes.object.isRequired,
}

export const pageQuery = graphql`
  query ProductPageData {
    file(name: { eq: "product" }, absolutePath: { regex: "/src/data/" }) {
      childMdx {
        frontmatter {
          title
          description
          hero {
            blurb
            heading
          }
        }
      }
    }
  }
`

export default Product
